import axios from 'axios'
import * as actions from '../../actionTypes'

import * as moment from 'moment'

const GET_CURRENT_TRANSACTION = 'GET_CURRENT_TRANSACTION'
const GET_CURRENT_TRANSACTION_SUCCESS = 'GET_CURRENT_TRANSACTION_SUCCESS'
const GET_CURRENT_TRANSACTION_FAILURE = 'GET_CURRENT_TRANSACTION_FAILURE'

const baseURL = process.env.REACT_APP_SERVICE_URL
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT

const initialState = {
  vehicleResponse: '',
  vehicleData: {}
}

const instance = axios.create({
  timeout: parseInt(timeout),
})

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_TRANSACTION_SUCCESS:
      return {
        ...state,
        vehicleResponse: action.payload.responseData,
      }
    case GET_CURRENT_TRANSACTION:
    case GET_CURRENT_TRANSACTION_FAILURE:
    case actions.CLEAR_PERMIT_INFO: {
      return saveVehicleData(state)
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default:
      return state
  }
}

const saveVehicleData = (state) => {
  const key = state.vehicleResponse?.vehicleValidation?.plateNumber
  const value = { ...state.vehicleResponse?.vehicleData, ...state.vehicleResponse?.vehicleValidation }
  if (!key || !value) {
    return {
      ...state,
      vehicleResponse: ''
    };
  }

  return {
    ...initialState,
    vehicleData: {
      ...state.vehicleData,
      [key]: value
    }
  }
}

export const processMasterNumberAction = (masterNumber, plateNumber, vinSerialNumber) => {
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_TRANSACTION })
    return instance.post(`${baseURL}services/vehiclepermitservice/api/ovprVehicleValidation`, { masterNumber: masterNumber, plateNumber: plateNumber, vehicleNumber: vinSerialNumber }).then(
      (response) => {
        if (response.status === 200) {
          let responseData = response['data']
          dispatch({
            type: GET_CURRENT_TRANSACTION_SUCCESS,
            payload: {
              responseData: responseData,
            },
          })
          return responseData
        } else {
          dispatch({ type: GET_CURRENT_TRANSACTION_FAILURE })
        }
      },
      (err) => {
        dispatch({ type: GET_CURRENT_TRANSACTION_FAILURE })
        throw new Error(`Error in getting data for ${masterNumber} ${plateNumber} ${vinSerialNumber}`)
      }
    )
  }
}

const dateTranslationMap = {
  "en": {
    months: "months",
    years: "years"
  },
  "fr": {
    months: "mois",
    years: "ans"
  }
}

export const parsePeriodText = (val, language) => {
  var year = moment().format('YYYY');
  //get current year plus one year
  var nextYear = moment().add(1, 'years').format('YYYY');


  if (val.length < 4) {
    const [, amt, duration] = val.split(/(\d+)/)
    const { months, years } = dateTranslationMap[language]
    if (duration === 'm') {
      return `${amt} ${months}`
    }
    else if (duration === 'y') {
      return `${amt} ${years}`
    }
    else {
      return ''
    }
  }
  else if (val.includes('-current')) {
    const [from, to] = val.split('-').map(date => {
      if (date === "current") {
        return '';
      }
      const localedDate = moment(date, 'MMMDD');
      localedDate.locale(language)
      return localedDate.format("MMM DD").toString() + ", " + year.toString();
    });
    const dateSeparator = language === "en" ? "to" : "à"
    return `${from} ${dateSeparator} ${to}`
  }
  else if (val.includes('-next')) {
    const [from, to] = val.split('-').map(date => {
      if (date === "next") {
        return '';
      }
      const localedDate = moment(date, 'MMMDD');
      localedDate.locale(language)
      // return localedDate.format("MMM DD")
      return localedDate.format("MMM DD").toString() + ", " + nextYear.toString();
    });
    const dateSeparator = language === "en" ? "to" : "à"
    return `${from} ${dateSeparator} ${to}`
  }
}